<template>
  <div class="dates-input">
    <MenuLabel
      class="dates-input__menu-label"
      :label="$t('STAY_DATES_HEADER')"
      :isOpen="isOpen"
      :value="selectedDates"
      @toggle="handleMenuToggled"
    />
    <component
      :is="$device.isMobile ? 'Drawer' : 'DropdownMenu'"
      :visible="isOpen"
      :fitsContent='true'
      class="location-input__menu-container"
      :title="$t('STAY_DATES_HEADER')"
      @close="handleMenuToggled"
    >
      <div class="dates-input__calendar">
        <Calendar
          :maxDate="datepickerEndDate"
          :viewType="calendarType"
          :isRangeSelection="true"
          dateFormat="yyyy-MM-dd"
          @dateSelection="handleDateSelection"
        />
      </div>
      <template v-if="$device.isMobile" #footer>
        <ShButton @click="handleMenuToggled" :fullWidth="true" :disabled="!Boolean(selectedDates)">
          {{ $t('STAY_MODIFY_BOOKING_CONFIRM_CTA') }}
        </ShButton>
      </template>
    </component>
  </div>
</template>

<script>
import { Calendar, DropdownMenu, MenuLabel, Drawer } from '@sohohouse/design-system'
import { decorators } from '@sohohouse/platform-resources'

import { calendarTypes } from '../../menuConfig'

const { shared: { DateTime } } = decorators

export default {
  name: 'BedroomsDatesMenu',
  components: {
    Calendar,
    DropdownMenu,
    MenuLabel,
    Drawer
  },

  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    selectedDates: {
      type: String,
      default: ''
    }
  },

  computed: {
    calendarType () {
      if (this.$device.isMobile) {
        return calendarTypes.mobile
      }
      if (this.$device.isTablet) {
        return calendarTypes.tablet
      }
      return calendarTypes.desktop
    },

    datepickerEndDate () {
      const date = new DateTime().add(1.5, 'year')
      return date.isoString
    }
  },


  methods: {
    handleDateSelection (dates) {
      this.$emit('datesSelected', dates)
    },

    handleMenuToggled () {
      this.$emit('menuToggle')
    }
  }
}
</script>

<style lang="scss" scoped>

$datepicker-tablet-width: 423px; // Doesn't line up at 425px

$datepicker-desktop-width: 60vw;
$datepicker-desktop-max-width: 944px;
$datepicker-desktop-padding: 1px;

// Taken from the parent components
$header-height: 75px;
$footer-height: $space-110;

.dates-input {
  &__calendar {
    overflow: scroll;

    @include tablet {
      position: unset;
      width: $datepicker-tablet-width;
    }

    @include desktop {
      position: unset;
      width: $datepicker-desktop-width;
      max-width: $datepicker-desktop-max-width;
      padding: 0 $datepicker-desktop-padding;
    }
  }
  &__menu-label {
    border-top-width: 0;

    @include tablet {
      border-top-width: 1px;
    }
  }
}

</style>
